import site from './site.json'
import { getLandingImageProps, heroImageSizes } from '../utils/landingImages'

const heroImage = getLandingImageProps(site.image, heroImageSizes)

export const applicationMetadata = [
  { tag: 'meta', attrs: { name: 'robots', content: 'noindex, nofollow' } },
  { tag: 'link', attrs: { rel: 'stylesheet', href: 'https://fonts.googleapis.com/css?family=Roboto:300,400,500,700,900&display=swap' } },
]

export const landingMetadata = [
  { tag: 'meta', attrs: { name: 'description', content: site.description } },
  { tag: 'meta', attrs: { name: 'robots', content: 'index, follow, max-image-preview:large' } },
  { tag: 'link', attrs: { rel: 'canonical', href: `${site.origin}/` } },
  { tag: 'meta', attrs: { property: 'og:type', content: 'website' } },
  { tag: 'meta', attrs: { property: 'og:site_name', content: site.name } },
  { tag: 'meta', attrs: { property: 'og:locale', content: 'en_US' } },
  { tag: 'meta', attrs: { property: 'og:title', content: site.title } },
  { tag: 'meta', attrs: { property: 'og:description', content: site.description } },
  { tag: 'meta', attrs: { property: 'og:url', content: `${site.origin}/` } },
  { tag: 'meta', attrs: { property: 'og:image', content: `${site.origin}${site.image}` } },
  { tag: 'meta', attrs: { property: 'og:image:alt', content: 'Home appliances supplied by Wholesale USA' } },
  { tag: 'meta', attrs: { name: 'twitter:card', content: 'summary_large_image' } },
  { tag: 'meta', attrs: { name: 'twitter:title', content: site.title } },
  { tag: 'meta', attrs: { name: 'twitter:description', content: site.description } },
  { tag: 'meta', attrs: { name: 'twitter:image', content: `${site.origin}${site.image}` } },
  { tag: 'link', attrs: { rel: 'preload', as: 'image', href: '/images/optimized/ge-1280.webp', imagesrcset: heroImage.srcSet, imagesizes: heroImage.sizes } },
  { tag: 'link', attrs: { rel: 'preload', as: 'font', type: 'font/woff2', href: '/fonts/montserrat-latin.woff2', crossorigin: 'anonymous' } },
]

export const structuredData = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      '@id': `${site.origin}/#organization`,
      name: site.name,
      url: `${site.origin}/`,
      logo: `${site.origin}${site.logo}`,
      description: site.description,
      foundingDate: site.foundingDate,
      telephone: site.telephone,
      email: site.email,
      address: site.address,
    },
    {
      '@type': 'WebSite',
      '@id': `${site.origin}/#website`,
      url: `${site.origin}/`,
      name: site.name,
      publisher: { '@id': `${site.origin}/#organization` },
      inLanguage: 'en-US',
    },
  ],
}

export const applyRouteMetadata = (pathname) => {
  document.head.querySelectorAll('[data-route-seo]').forEach((element) => element.remove())
  const isHome = pathname === '/'
  document.title = isHome ? site.title : site.name
  const metadata = isHome
    ? landingMetadata
    : applicationMetadata
  metadata.forEach(({ tag, attrs }) => {
    const element = document.createElement(tag)
    element.setAttribute('data-route-seo', 'true')
    Object.entries(attrs).forEach(([name, value]) => element.setAttribute(name, value))
    document.head.appendChild(element)
  })
  if (isHome) {
    const element = document.createElement('script')
    element.type = 'application/ld+json'
    element.setAttribute('data-route-seo', 'true')
    element.textContent = JSON.stringify(structuredData)
    document.head.appendChild(element)
  }
}
